import React, { useEffect, useState } from "react";
import "../OrderReview.css";
import PrimaryButton from "../../../Helpers/Buttons/PrimaryButton";

const BillingSection = ({
  setSectionRef,
  isPoNumberVerified,
  showBillToAddressList,
  setShowBillToAddressList,
  billingInfo,
  handlePoNumberChange,
  poNullError,
  verifyPoNumber,
  userAccountInfo,
  billToAddresses,
  selectBillToAddress,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Default address
  const [selectedBillToAddressId, setSelectedBillToAddressId] = useState(() => {
    const defaultAddress = billToAddresses.find(
      (address) => address.defaultTypeId
    );
    return defaultAddress ? defaultAddress.erpAddressId : null;
  });

  const toggleBillToAddressList = () => {
    setShowBillToAddressList(!showBillToAddressList);
  };

  // Mark selected address radio button
  useEffect(() => {
    if (billToAddresses.length > 0) {
      const defaultAddress = billToAddresses.find(
        (address) => address.defaultTypeId
      );
      if (defaultAddress) {
        setSelectedBillToAddressId(defaultAddress.erpAddressId);
      }
    }
  }, [selectBillToAddress]);

  return (
    <div
      ref={setSectionRef(2)}
      style={{
        minHeight: showBillToAddressList ? "auto" : 0,
        marginBottom: "30px",
      }}
    >
      {/* Billing Information Section */}
      <h2 className="section-title">3. Billing Information</h2>
      <div className="section-content">
        {/* Default Billing Address */}
        <div className="default-billing-address">
          <div>
            <div className="po-number-container">
              <div
                className="tooltip-icon"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 9H5.4V5.4H6.6V9ZM6.6 4.2H5.4V3H6.6V4.2Z"
                    fill="#04ADD1"
                    fillOpacity="0.8"
                  />
                </svg>
                {showTooltip && (
                  <div className="tooltip">
                    Do not use your Account Number as a PO Number.
                  </div>
                )}
              </div>

              <span className="po-number-label">PO Number</span>
              <span className="required-label">(Required)</span>

              <input
                id="ponumber"
                type="text"
                style={{}}
                className={`po-number-input ${poNullError ? "warning" : ""}`}
                value={billingInfo.poNumber}
                onChange={handlePoNumberChange}
                placeholder={
                  poNullError ? "Please enter a PO Number" : "ex) MVN-DEC1524"
                }
                required
              />
              <button
                type="button"
                className="verify-button"
                onClick={() =>
                  verifyPoNumber(
                    billingInfo.poNumber,
                    userAccountInfo.erpCustomerId
                  )
                }
              >
                Verify
              </button>
              {isPoNumberVerified && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  style={{ marginLeft: "10px" }}
                >
                  <path
                    d="M8 16C9.09428 16 10.1246 15.7902 11.0911 15.3707C12.0575 14.9564 12.9064 14.3808 13.6376 13.6441C14.3739 12.9074 14.9517 12.0582 15.371 11.0964C15.7903 10.1295 16 9.09608 16 7.99616C16 6.90136 15.7903 5.87306 15.371 4.91127C14.9517 3.94436 14.3739 3.09257 13.6376 2.35588C12.9064 1.61918 12.055 1.04364 11.0834 0.62926C10.117 0.209752 9.08661 0 7.99233 0C6.89805 0 5.86769 0.209752 4.90125 0.62926C3.9348 1.04364 3.08341 1.61918 2.34708 2.35588C1.61585 3.09257 1.04059 3.94436 0.621285 4.91127C0.207095 5.87306 0 6.90136 0 7.99616C0 9.09608 0.207095 10.1295 0.621285 11.0964C1.04059 12.0582 1.61841 12.9074 2.35475 13.6441C3.09108 14.3808 3.94247 14.9564 4.90892 15.3707C5.87536 15.7902 6.90572 16 8 16ZM7.14861 11.8024C6.99009 11.8024 6.84692 11.7691 6.71908 11.7026C6.59124 11.631 6.47108 11.5236 6.35858 11.3803L4.51007 9.15492C4.43848 9.05771 4.38223 8.96307 4.34132 8.87098C4.30553 8.77378 4.28763 8.67402 4.28763 8.5717C4.28763 8.35683 4.36178 8.17522 4.51007 8.02686C4.65836 7.87338 4.83989 7.79664 5.05465 7.79664C5.18249 7.79664 5.29754 7.82478 5.39981 7.88105C5.50208 7.93221 5.60435 8.02174 5.70662 8.14964L7.1256 9.93L10.2167 4.98801C10.4008 4.6964 10.6283 4.5506 10.8993 4.5506C11.1039 4.5506 11.2854 4.61711 11.4439 4.75012C11.6075 4.88313 11.6894 5.05707 11.6894 5.27194C11.6894 5.36914 11.6689 5.46635 11.628 5.56355C11.5922 5.66075 11.5462 5.75284 11.4899 5.83981L7.90796 11.3803C7.81592 11.5133 7.70342 11.6182 7.57047 11.695C7.44263 11.7666 7.30201 11.8024 7.14861 11.8024Z"
                    fill="var(--Verified-Green, #35E37A)"
                  />
                </svg>
              )}
            </div>

            <div>
              <span className="company-name" style={{ fontWeight: "bold" }}>
                {billingInfo.companyName}
                {selectedBillToAddressId &&
                billingInfo?.defaultTypeId === true &&
                billingInfo?.erpAddressId === selectedBillToAddressId ? (
                  <span style={{ fontWeight: "bold", marginLeft: "10px" }}>
                    (Default)
                  </span>
                ) : null}
              </span>
              <br />
              <br />
              <span className="company-address">{billingInfo.address1}</span>
              <br />
              <span className="company-address">
                {billingInfo.address2 ? `${billingInfo.address2} \n` : null}
                {billingInfo.city},{billingInfo.stateName},{billingInfo.zipCode}
              </span>
              <br />
              <span className="company-address">{billingInfo.countryName}</span>
              <br /> <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingSection;
